<div
    class="user-text table-responsive wysiwyg as-html max-width-100"
    [innerHTML]="html"
></div>
<p *ngIf="linkedProtocol">
    <br />
    <button class="btn btn-primary" [routerLink]="'/protocols/' + linkedProtocol">Open Document</button>
</p>
